module.exports = __webpack_public_path__ + "img/success_icon_dark.8689f860.svg";